import React, {useEffect, useState} from 'react'
import { observer, inject } from "mobx-react"

import Helmet from "react-helmet";

import Layout from "../components/layout"
import Seo from "../components/seo"
import Section from "../components/template-partials/global-components/section"

const ContactPage = inject(`store`)(observer(({ store, children }) => {
  const [isHcp, setIsHcp] = useState(false);
  useEffect(()=>{
    if(window.location.hash) {
      // Fragment exists
      document.documentElement.scrollTop = 0;
      if(window.location.hash === "#hcp"){
        setIsHcp(true);
        store.hcpStore.updateProp('isHcp', true);
      }
    } else {
      setIsHcp(false);
      store.hcpStore.updateProp('isHcp', false);
    }
  },[]);
  return (
    <Layout>
      {isHcp &&
        <Helmet>
          <body className="hcp-layout" />
        </Helmet>
      }
      {!isHcp &&
        <Helmet>
          <body className="cg-layout" />
        </Helmet>
      }
      <Seo title="Contact Us" description="Get in touch with us." />
      <div className="page-heading">
        <div className="row">
          <div className="columns">
            <h1 className="page-heading__heading">Contact Us</h1>
          </div>
        </div>
      </div>
      <Section>
        <div className="row">
          <div className="columns">
            <p>If you have questions about Unituxin<sup>&reg;</sup>, please call Customer Service at <strong>1-877-UNITHER</strong> (1-877-864-8437).</p>

            <p>
            <strong>CORPORATE HEADQUARTERS </strong><br/>
            1040 Spring Street <br/>
            Silver Spring, Maryland 20910 <br/>
            Tel. (301) 608-9292 <br/>
            Fax. (301) 608-9291
            </p>

            <p>
            <strong>RESEARCH TRIANGLE PARK OFFICES</strong><br/>
            55 T.W. Alexander Drive <br/>
            P.O. Box 14186 <br/>
            Research Triangle Park, North Carolina 27709 <br/>
            Tel. (919) 485-8350 <br/>
            Fax. (919) 485-8352
            </p>

            <p>You may also contact United Therapeutics Corporation at <strong>1-877-864-8437</strong> or via email at <a href='mailt&#111;&#58;m&#97;i%6C&#116;o&#58;dr&#117;g%7&#51;%61&#102;%65t%&#55;9&#64;u%6Ei&#116;her&#46;&#37;63&#111;m'>d&#114;ugsa&#102;et&#121;&#64;unith&#101;r&#46;&#99;om</a> to report suspected side effects, or contact the FDA at <strong>1-800-FDA-1088</strong> or <a href="http://www.fda.gov/Safety/MedWatch" target="_blank" rel="noreferrer">www.fda.gov/Safety/MedWatch</a>.</p>
          </div>
        </div>
      </Section>
    </Layout>
  );
}));

export default ContactPage
